import './app.css';

const EDITORIAL_HEADING_SELECTOR = 'h1, h2, h3, h4, h5, h6';
const EDITORIAL_TEXT_EXCLUSIONS = 'script, style, code, pre, textarea, input, select, option';

function textNodes(element) {
  const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
  const nodes = [];
  let node = walker.nextNode();
  while (node) {
    if (!node.parentElement?.closest(EDITORIAL_TEXT_EXCLUSIONS)) {
      nodes.push(node);
    }
    node = walker.nextNode();
  }
  return nodes;
}

function applyEditorialTypography(root = document.body) {
  textNodes(root).forEach((node) => {
    const normalized = node.nodeValue.replace(/[—–]/g, '-');
    if (normalized !== node.nodeValue) {
      node.nodeValue = normalized;
    }
  });

  root.querySelectorAll(EDITORIAL_HEADING_SELECTOR).forEach((element) => {
    const nodes = textNodes(element);
    nodes.forEach((node) => {
      node.nodeValue = node.nodeValue.replace(/\.(\s*)$/, '$1');
    });
  });
}

function pluralizeRu(count, [one, few, many]) {
  const absolute = Math.abs(count);
  const lastTwoDigits = absolute % 100;
  const lastDigit = absolute % 10;
  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) return many;
  if (lastDigit === 1) return one;
  if (lastDigit >= 2 && lastDigit <= 4) return few;
  return many;
}

const nav = document.getElementById('site-nav');
const mobileMenu = document.getElementById('mobile-menu');
const burgerIcon = document.getElementById('burger-icon');
const menuToggle = document.querySelector('.js-toggle-menu');
const desktopMenu = document.querySelector('.js-desktop-menu');
const desktopMenuTriggers = [...document.querySelectorAll('.js-nav-trigger')];
const mobileAccordionButtons = [...document.querySelectorAll('.js-acc')];

const syncNavScrolled = () => {
  const scrolled = window.scrollY > 8;
  nav?.classList.toggle('navbar--scrolled', scrolled);
  document.documentElement.classList.toggle('is-nav-scrolled', scrolled);
};

syncNavScrolled();
window.addEventListener('scroll', syncNavScrolled, { passive: true });

function setMobileMenu(open) {
  if (!mobileMenu || !menuToggle) {
    return;
  }
  mobileMenu.classList.toggle('is-open', open);
  mobileMenu.hidden = !open;
  menuToggle.setAttribute('aria-expanded', String(open));
  menuToggle.setAttribute('aria-label', open ? 'Закрыть меню' : 'Открыть меню');
  document.documentElement.classList.toggle('mobile-menu-open', open);
  if (open) {
    syncSiteNavHeight();
    syncSiteMenuMaxHeight();
  }
  if (burgerIcon) {
    burgerIcon.className = open ? 'text-2xl ri-close-line' : 'text-2xl ri-menu-line';
  }
}

menuToggle?.addEventListener('click', () => {
  setMobileMenu(!mobileMenu?.classList.contains('is-open'));
});

function setMobileAccordion(button, open) {
  const panel = document.getElementById(`acc-${button.dataset.acc}`);
  button.classList.toggle('is-open', open);
  button.setAttribute('aria-expanded', String(open));
  if (panel) {
    panel.classList.toggle('is-open', open);
    panel.hidden = !open;
  }
}

mobileAccordionButtons.forEach((button) => {
  button.addEventListener('click', () => {
    const open = button.getAttribute('aria-expanded') !== 'true';
    mobileAccordionButtons.forEach((otherButton) => {
      setMobileAccordion(otherButton, otherButton === button && open);
    });
  });
});

mobileMenu?.querySelectorAll('a, .js-open-demo').forEach((link) => {
  link.addEventListener('click', () => setMobileMenu(false));
});

function syncSiteNavHeight() {
  const height = nav?.getBoundingClientRect().height;
  if (!height) {
    return;
  }
  const navHeight = Math.round(height);
  if (nav.dataset.measuredHeight !== String(navHeight)) {
    nav.dataset.measuredHeight = String(navHeight);
    document.documentElement.style.setProperty('--site-nav-height', `${navHeight}px`);
  }
}

function syncSiteMenuMaxHeight() {
  const measured = Number(nav?.dataset.measuredHeight);
  const navHeight = Number.isFinite(measured) && measured > 0
    ? measured
    : Math.round(nav?.getBoundingClientRect().height || 0);
  const menuHeight = `${Math.max(0, window.innerHeight - navHeight)}px`;
  if (document.documentElement.style.getPropertyValue('--site-menu-max-height') !== menuHeight) {
    document.documentElement.style.setProperty('--site-menu-max-height', menuHeight);
  }
}

function updateMenuScrollHint(panel) {
  const list = panel.querySelector('.nav-mega__grid');
  if (!list) {
    return;
  }
  const remaining = list.scrollHeight - list.clientHeight - list.scrollTop;
  panel.classList.toggle('is-menu-scrollable', list.scrollHeight > list.clientHeight + 8);
  panel.classList.toggle('is-menu-end', remaining < 8);
}

function watchMenuScroll(panel) {
  const list = panel.querySelector('.nav-mega__grid');
  if (!list) {
    return;
  }
  updateMenuScrollHint(panel);
  if (list.dataset.scrollHint === '1') {
    return;
  }
  list.dataset.scrollHint = '1';
  list.addEventListener('scroll', () => updateMenuScrollHint(panel), { passive: true });
  if (typeof ResizeObserver !== 'undefined') {
    const observer = new ResizeObserver(() => updateMenuScrollHint(panel));
    observer.observe(list);
  }
}

function setDesktopDisclosure(button, open) {
  const disclosure = button.closest('.js-nav-disclosure');
  const panel = document.getElementById(button.getAttribute('aria-controls'));
  if (!disclosure || !panel) {
    return;
  }
  disclosure.classList.toggle('is-open', open);
  button.setAttribute('aria-expanded', String(open));
  panel.hidden = !open;
  if (open) {
    syncSiteNavHeight();
    syncSiteMenuMaxHeight();
    window.requestAnimationFrame(() => watchMenuScroll(panel));
  }
}

function closeDesktopDisclosures(except = null) {
  desktopMenuTriggers.forEach((button) => {
    if (button !== except) {
      setDesktopDisclosure(button, false);
    }
  });
}

desktopMenuTriggers.forEach((button, triggerIndex) => {
  const panel = document.getElementById(button.getAttribute('aria-controls'));

  button.addEventListener('click', () => {
    const open = button.getAttribute('aria-expanded') !== 'true';
    closeDesktopDisclosures(button);
    setDesktopDisclosure(button, open);
  });

  button.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      closeDesktopDisclosures(button);
      setDesktopDisclosure(button, true);
      const links = [...panel?.querySelectorAll('a') || []];
      (event.key === 'ArrowDown' ? links[0] : links.at(-1))?.focus();
    } else if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault();
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      const nextIndex = (triggerIndex + direction + desktopMenuTriggers.length) % desktopMenuTriggers.length;
      desktopMenuTriggers[nextIndex]?.focus();
    } else if (event.key === 'Escape') {
      setDesktopDisclosure(button, false);
    }
  });

  panel?.addEventListener('keydown', (event) => {
    const links = [...panel.querySelectorAll('a')];
    const currentIndex = links.indexOf(document.activeElement);
    if (event.key === 'Escape') {
      event.preventDefault();
      setDesktopDisclosure(button, false);
      button.focus();
    } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      const direction = event.key === 'ArrowDown' ? 1 : -1;
      const nextIndex = (currentIndex + direction + links.length) % links.length;
      links[nextIndex]?.focus();
    } else if (event.key === 'Home' || event.key === 'End') {
      event.preventDefault();
      (event.key === 'Home' ? links[0] : links.at(-1))?.focus();
    }
  });
});

desktopMenu?.addEventListener('focusout', () => {
  window.setTimeout(() => {
    if (!desktopMenu.contains(document.activeElement)) {
      closeDesktopDisclosures();
    }
  });
});

document.addEventListener('click', (event) => {
  if (!desktopMenu?.contains(event.target)) {
    closeDesktopDisclosures();
  }
});

syncSiteNavHeight();
syncSiteMenuMaxHeight();
let viewportWidth = window.innerWidth;
window.addEventListener('resize', () => {
  if (window.innerWidth === viewportWidth) {
    return;
  }
  viewportWidth = window.innerWidth;
  syncSiteNavHeight();
  syncSiteMenuMaxHeight();
  if (window.innerWidth <= 300) {
    closeDesktopDisclosures();
  } else {
    setMobileMenu(false);
  }
});

document.querySelectorAll('.js-open-demo').forEach((button) => {
  button.addEventListener('click', () => {
    const modal = document.getElementById('demo-modal');
    const title = modal?.querySelector('#demo-title');
    const subtitle = modal?.querySelector('.rm-dialog__subtitle');
    if (title) {
      title.textContent = button.dataset.demoTitle || 'Запросить демо';
    }
    if (subtitle) {
      subtitle.textContent = button.dataset.demoSubtitle
        || 'Напишите, с чем вам помочь - обсудим задачу и покажем, как RedMule решает её на практике';
    }
    openOverlay('demo-modal');
  });
});

document.querySelectorAll('.js-open-modal').forEach((button) => {
  button.addEventListener('click', () => openOverlay(button.dataset.modal));
});

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) {
    return;
  }
  const note = target.closest('.js-license-note');
  if (note) {
    openLicenseNote(note);
    return;
  }
  const edition = target.closest('.js-license-edition');
  if (edition) {
    openLicenseEdition(edition);
  }
});

function licenseModal() {
  const modal = document.getElementById('license-note');
  if (modal && modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }
  return modal;
}

function openLicenseNote(button) {
  const modal = licenseModal();
  if (!modal) {
    return;
  }
  const title = modal.querySelector('#license-note-title');
  const body = modal.querySelector('[data-license-note-body]');
  const kicker = modal.querySelector('[data-license-kicker]');
  if (kicker) {
    kicker.textContent = 'О возможности';
  }
  if (title) {
    title.textContent = button.dataset.licenseTitle || '';
  }
  if (body) {
    body.textContent = button.dataset.licenseNote || '';
  }
  setLicenseField(modal, '[data-license-free-name]', button.dataset.licenseFreeName || '');
  setLicenseField(modal, '[data-license-free-value]', button.dataset.licenseFreeValue || '');
  setLicenseField(modal, '[data-license-enterprise-name]', button.dataset.licenseEnterpriseName || '');
  setLicenseField(modal, '[data-license-enterprise-value]', button.dataset.licenseEnterpriseValue || '');
  toggleLicenseBlock(modal, '[data-license-compare]', false);
  toggleLicenseBlock(modal, '[data-license-diff]', true);
  toggleLicenseBlock(modal, '[data-license-same]', true);
  openOverlay('license-note');
}

function openLicenseEdition(button) {
  const modal = licenseModal();
  if (!modal) {
    return;
  }
  const title = modal.querySelector('#license-note-title');
  const body = modal.querySelector('[data-license-note-body]');
  const kicker = modal.querySelector('[data-license-kicker]');
  const edition = button.dataset.edition === 'enterprise' ? 'enterprise' : 'free';
  if (kicker) {
    kicker.textContent = 'Редакция';
  }
  if (title) {
    title.textContent = button.dataset.editionName || '';
  }
  if (body) {
    body.textContent = button.dataset.editionPitch || '';
  }
  const list = modal.querySelector('[data-license-diff]');
  if (list) {
    list.replaceChildren();
    document.querySelectorAll('.js-license-note').forEach((row) => {
      const free = row.dataset.licenseFreeValue || '';
      const enterprise = row.dataset.licenseEnterpriseValue || '';
      if (free === enterprise) {
        return;
      }
      const item = document.createElement('li');
      const name = document.createElement('span');
      name.textContent = row.dataset.licenseTitle || '';
      const value = document.createElement('strong');
      const text = edition === 'enterprise' ? enterprise : free;
      value.textContent = text;
      value.dataset.tone = text === 'Нет' ? 'no' : 'yes';
      item.append(name, value);
      list.append(item);
    });
  }
  const hasDiff = Boolean(list && list.children.length);
  const same = modal.querySelector('[data-license-same]');
  if (same) {
    same.textContent = hasDiff
      ? 'По остальным пунктам редакции совпадают.'
      : 'Редакции совпадают по всем пунктам этой таблицы.';
  }
  toggleLicenseBlock(modal, '[data-license-compare]', true);
  toggleLicenseBlock(modal, '[data-license-diff]', !hasDiff);
  toggleLicenseBlock(modal, '[data-license-same]', false);
  openOverlay('license-note');
}

function setLicenseField(modal, selector, value) {
  modal.querySelectorAll(selector).forEach((node) => {
    node.textContent = value;
  });
}

function toggleLicenseBlock(modal, selector, hidden) {
  modal.querySelectorAll(selector).forEach((node) => {
    node.hidden = hidden;
  });
}

document.querySelectorAll('.js-close-modal').forEach((node) => {
  node.addEventListener('click', () => closeOverlay(node.closest('.rm-overlay')));
});

document.querySelectorAll('.rm-overlay').forEach((overlay) => {
  let pointerStartedOnBackdrop = false;

  overlay.addEventListener('pointerdown', (event) => {
    pointerStartedOnBackdrop = event.target === overlay;
  });

  overlay.addEventListener('pointerup', (event) => {
    if (pointerStartedOnBackdrop && event.target === overlay) {
      closeOverlay(overlay);
    }
    pointerStartedOnBackdrop = false;
  });

  overlay.addEventListener('pointercancel', () => {
    pointerStartedOnBackdrop = false;
  });
});

const overlayTriggers = new WeakMap();
let overlayScrollY = 0;

function lockPageScroll() {
  if (document.documentElement.classList.contains('no-scroll')) {
    return;
  }
  overlayScrollY = window.scrollY;
  document.documentElement.classList.add('no-scroll');
  document.body.classList.add('no-scroll');
  document.body.style.top = `-${overlayScrollY}px`;
}

function unlockPageScroll() {
  document.documentElement.classList.remove('no-scroll');
  document.body.classList.remove('no-scroll');
  document.body.style.removeProperty('top');
  window.scrollTo(0, overlayScrollY);
}

function openOverlay(id) {
  const modal = document.getElementById(id);
  if (!modal) {
    return;
  }
  const trigger = document.activeElement instanceof HTMLElement ? document.activeElement : null;
  overlayTriggers.set(modal, trigger);
  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');
  lockPageScroll();
  modal.querySelector('button')?.focus();
}

function closeOverlay(modal) {
  if (!(modal instanceof HTMLElement)) {
    return;
  }
  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  if (!document.querySelector('.rm-overlay.is-open')) {
    unlockPageScroll();
  }
  overlayTriggers.get(modal)?.focus();
  overlayTriggers.delete(modal);
}

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const openOverlays = document.querySelectorAll('.rm-overlay.is-open');
    closeOverlay(openOverlays.item(openOverlays.length - 1));
  }
});

async function submitDemo(form) {
  const error = form.querySelector('[data-demo-error]');
  const ok = form.querySelector('[data-demo-ok]');
  error?.classList.remove('is-on');
  ok?.classList.remove('is-on');

  const data = Object.fromEntries(new FormData(form).entries());
  const payload = {
    name: data.name || ' ',
    company: data.company || ' ',
    email: String(data.email || '').trim(),
    description: String(data.description || '').trim(),
  };

  const consent = form.querySelector('[name="privacyConsent"]');
  const consentLabel = consent?.closest('.rm-consent');
  consentLabel?.classList.remove('is-invalid');

  if (!form.checkValidity()) {
    if (consent && !consent.checked) {
      consentLabel?.classList.add('is-invalid');
      if (error) {
        error.textContent = 'Подтвердите согласие на обработку персональных данных.';
        error.classList.add('is-on');
      }
    }
    const invalid = form.querySelector(':invalid');
    if (invalid && invalid !== consent) {
      invalid.focus();
    }
    return;
  }

  try {
    const response = await fetch('/api/v1/request-demo', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      throw new Error('request failed');
    }
    form.querySelectorAll('[data-demo-contact]').forEach((node) => {
      node.textContent = payload.email;
    });
    form.querySelectorAll('[data-demo-description]').forEach((node) => {
      node.textContent = payload.description || 'Без дополнительного сообщения';
    });
    form.reset();
    const chars = form.querySelector('.js-chars');
    if (chars) {
      chars.textContent = '0';
    }
    form.classList.add('is-submitted');
    ok?.classList.add('is-on');
  } catch (ex) {
    if (error) {
      error.textContent = 'Не удалось отправить заявку. Попробуйте позже.';
      error.classList.add('is-on');
    }
  }
}

document.querySelectorAll('.js-demo-form').forEach((form) => {
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    submitDemo(form);
  });
  form.querySelector('[name="privacyConsent"]')?.addEventListener('change', () => {
    form.querySelector('.rm-consent')?.classList.remove('is-invalid');
    form.querySelector('[data-demo-error]')?.classList.remove('is-on');
  });
  form.querySelector('[data-demo-reset]')?.addEventListener('click', () => {
    form.classList.remove('is-submitted');
    form.querySelector('[data-demo-ok]')?.classList.remove('is-on');
    form.querySelector('[name="email"]')?.focus();
  });
});

document.querySelectorAll('.js-char-count').forEach((area) => {
  const counter = area.parentElement?.querySelector('.js-chars');
  area.addEventListener('input', () => {
    if (counter) {
      counter.textContent = String(area.value.length);
    }
  });
});

const benefitTrack = document.getElementById('benefit-track');
const benefitTabs = [...document.querySelectorAll('.js-benefit-tab')];

const centerTabInStrip = (tab, smooth = true) => {
  if (!tab || !window.matchMedia('(max-width: 767px)').matches) {
    return;
  }
  const strip = tab.closest('.rm-mobile-tab-strip');
  if (!strip) {
    return;
  }
  const tabs = [...strip.querySelectorAll('.rm-feature-tab')];
  const styles = window.getComputedStyle(strip);
  const gap = Number.parseFloat(styles.columnGap) || 0;
  const contentWidth = tabs.reduce((width, item) => width + item.offsetWidth, 0) + gap * Math.max(0, tabs.length - 1);
  const overflowing = contentWidth > strip.clientWidth - 32;
  strip.classList.toggle('is-overflowing', overflowing);
  if (!overflowing) {
    strip.scrollTo({ left: 0, behavior: 'auto' });
    return;
  }
  const tabIndex = tabs.indexOf(tab);
  const lastTabIndex = tabs.length - 1;
  let scrollLeft;
  if (tabIndex === 0) {
    scrollLeft = 0;
  } else if (tabIndex === lastTabIndex) {
    scrollLeft = strip.scrollWidth - strip.clientWidth;
  } else {
    scrollLeft = tab.offsetLeft - (strip.clientWidth - tab.offsetWidth) / 2;
  }
  strip.scrollTo({
    left: scrollLeft,
    behavior: smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto',
  });
};

const selectBenefitTab = (tabIndex, smooth = true) => {
  if (benefitTrack) {
    benefitTrack.style.transform = `translateX(-${tabIndex * 100}%)`;
  }
  benefitTabs.forEach((tabButton, index) => {
    const active = index === tabIndex;
    tabButton.classList.toggle('is-active', active);
    tabButton.setAttribute('aria-selected', String(active));
    tabButton.tabIndex = active ? 0 : -1;
    if (active) {
      centerTabInStrip(tabButton, smooth);
    }
  });
};

benefitTabs.forEach((button) => {
  button.addEventListener('click', () => {
    selectBenefitTab(Number(button.dataset.tab || 0));
  });
});

const featureTabs = [...document.querySelectorAll('.js-feature-tab')];
const featureCards = document.querySelectorAll('[data-feature-card]');

const selectFeatureGroup = (group, smooth = true) => {
  featureTabs.forEach((tab) => {
    const active = tab.dataset.featureTab === group;
    tab.classList.toggle('is-active', active);
    tab.setAttribute('aria-selected', String(active));
    tab.tabIndex = active ? 0 : -1;
    if (active) {
      centerTabInStrip(tab, smooth);
    }
  });
  featureCards.forEach((card) => {
    card.hidden = card.dataset.featureCard !== group;
  });
};

featureTabs.forEach((button) => {
  button.addEventListener('click', () => {
    selectFeatureGroup(button.dataset.featureTab);
  });
});

if (featureTabs.length > 0) {
  selectFeatureGroup(featureTabs[0].dataset.featureTab, false);
}
if (benefitTabs.length > 0) {
  selectBenefitTab(0, false);
}

const refreshMobileTabStrips = () => {
  document.querySelectorAll('.rm-mobile-tab-strip').forEach((strip) => {
    centerTabInStrip(strip.querySelector('.rm-feature-tab.is-active'), false);
  });
};

window.addEventListener('resize', refreshMobileTabStrips);
window.addEventListener('load', refreshMobileTabStrips);

const tourSteps = Array.from(document.querySelectorAll('.js-tour-step'));
const tourPanels = Array.from(document.querySelectorAll('.js-tour-panel'));
const tourCurrentIndex = document.querySelector('.js-tour-current-index');
const tourCurrentTitle = document.querySelector('.js-tour-current-title');

const tourStepContainer = tourSteps[0]?.closest('.rm-tour__steps');
const tourStripQuery = window.matchMedia('(max-width: 767px)');

const placeTourStep = (index, smooth = true) => {
  if (!tourStripQuery.matches || !tourStepContainer) {
    return;
  }
  const step = tourSteps[index];
  if (!step) {
    return;
  }
  const maxLeft = Math.max(0, tourStepContainer.scrollWidth - tourStepContainer.clientWidth);
  let targetLeft = 0;
  if (index > 0 && index < tourSteps.length - 1) {
    targetLeft = step.offsetLeft - (tourStepContainer.clientWidth - step.offsetWidth) / 2;
  } else if (index === tourSteps.length - 1) {
    targetLeft = maxLeft;
  }
  targetLeft = Math.min(Math.max(0, targetLeft), maxLeft);
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  tourStepContainer.scrollTo({
    left: targetLeft,
    behavior: smooth && !reducedMotion ? 'smooth' : 'auto',
  });
};

const selectTourStep = (index, moveFocus = false) => {
  if (tourSteps.length === 0) {
    return;
  }
  const selectedIndex = (index + tourSteps.length) % tourSteps.length;
  tourSteps.forEach((step, stepIndex) => {
    const active = stepIndex === selectedIndex;
    step.classList.toggle('is-active', active);
    step.setAttribute('aria-selected', String(active));
    step.tabIndex = active ? 0 : -1;
  });
  tourPanels.forEach((panel, panelIndex) => {
    const active = panelIndex === selectedIndex;
    panel.hidden = !active;
    panel.classList.toggle('is-active', active);
  });
  const title = tourSteps[selectedIndex].querySelector('strong')?.textContent?.trim() || '';
  if (tourCurrentIndex) {
    tourCurrentIndex.textContent = `${String(selectedIndex + 1).padStart(2, '0')} / ${String(tourSteps.length).padStart(2, '0')}`;
  }
  if (tourCurrentTitle) {
    tourCurrentTitle.textContent = title;
  }
  placeTourStep(selectedIndex, true);
  if (moveFocus) {
    tourSteps[selectedIndex].focus();
  }
};

window.addEventListener('resize', () => {
  const activeIndex = tourSteps.findIndex((step) => step.classList.contains('is-active'));
  placeTourStep(Math.max(0, activeIndex), false);
});
placeTourStep(0, false);

tourSteps.forEach((button, index) => {
  button.addEventListener('click', () => selectTourStep(index));
  button.addEventListener('keydown', (event) => {
    let targetIndex;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      targetIndex = index + 1;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      targetIndex = index - 1;
    } else if (event.key === 'Home') {
      targetIndex = 0;
    } else if (event.key === 'End') {
      targetIndex = tourSteps.length - 1;
    }
    if (targetIndex !== undefined) {
      event.preventDefault();
      selectTourStep(targetIndex, true);
    }
  });
});

document.querySelectorAll('.js-tour-zoom').forEach((button) => {
  button.addEventListener('click', () => {
    const lightbox = document.getElementById('tour-lightbox');
    const image = lightbox?.querySelector('.rm-tour-lightbox__image');
    if (!lightbox || !image) {
      return;
    }
    if (lightbox.parentElement !== document.body) {
      document.body.appendChild(lightbox);
    }
    image.src = button.dataset.tourSrc || '';
    image.alt = button.dataset.tourAlt || '';
    const dialog = lightbox.querySelector('.rm-tour-lightbox__dialog');
    if (dialog) {
      dialog.scrollTop = 0;
      dialog.scrollLeft = 0;
    }
    openOverlay('tour-lightbox');
  });
});

function loadOfficeMap(container) {
  if (!container || container.classList.contains('is-loaded')) {
    return;
  }
  const src = container.dataset.mapSrc;
  if (!src) {
    return;
  }
  const iframe = document.createElement('iframe');
  iframe.className = 'office-map__frame';
  iframe.title = container.dataset.mapTitle || 'Карта проезда';
  iframe.loading = 'lazy';
  iframe.referrerPolicy = 'no-referrer-when-downgrade';
  iframe.setAttribute('allowfullscreen', '');
  iframe.src = src;
  container.appendChild(iframe);
  container.classList.add('is-loaded');
}

document.querySelectorAll('.js-office-map-load').forEach((button) => {
  button.addEventListener('click', () => {
    const container = button.closest('.js-office-map');
    loadOfficeMap(container);
  });
});

document.querySelectorAll('.js-office-tab').forEach((button) => {
  button.addEventListener('click', () => {
    const id = button.dataset.office;
    document.querySelectorAll('.js-office-tab').forEach((tab) => {
      tab.classList.toggle('is-active', tab === button);
    });
    document.querySelectorAll('[data-office-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.officePanel !== id;
    });
  });
});

const trusted = document.getElementById('trusted-viewport');
const trustedTrack = document.getElementById('trusted-track');
if (trusted && trustedTrack) {
  const originals = [...trustedTrack.children];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const desktop = window.matchMedia('(min-width: 768px)');
  let dragging = false;
  let paused = false;
  let startX = 0;
  let startScroll = 0;
  let lastT = performance.now();
  let cycleWidth = 0;

  const normalizeScroll = () => {
    if (cycleWidth > 10) {
      while (trusted.scrollLeft >= cycleWidth) {
        trusted.scrollLeft -= cycleWidth;
      }
      while (trusted.scrollLeft < 0) {
        trusted.scrollLeft += cycleWidth;
      }
    }
  };

  const enableLoop = () => {
    if (reducedMotion || originals.length < 2 || trustedTrack.scrollWidth <= trusted.clientWidth) {
      trusted.classList.add('is-static');
      return false;
    }
    const gap = Number.parseFloat(window.getComputedStyle(trustedTrack).columnGap) || 0;
    cycleWidth = trustedTrack.scrollWidth + gap;
    originals.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('img').forEach((image) => {
        image.alt = '';
      });
      trustedTrack.appendChild(clone);
    });
    trusted.classList.add('is-looping');
    return true;
  };

  const tick = (t) => {
    const dt = Math.min(50, Math.max(0, t - lastT));
    lastT = t;
    if (!dragging && !paused && desktop.matches) {
      trusted.scrollLeft += (42 * dt) / 1000;
      normalizeScroll();
    }
    requestAnimationFrame(tick);
  };

  trusted.addEventListener('pointerdown', (event) => {
    dragging = true;
    startX = event.clientX;
    startScroll = trusted.scrollLeft;
    trusted.classList.add('is-dragging');
    trusted.setPointerCapture(event.pointerId);
  });
  trusted.addEventListener('pointermove', (event) => {
    if (!dragging) {
      return;
    }
    trusted.scrollLeft = startScroll - (event.clientX - startX);
    normalizeScroll();
  });
  const stopDrag = () => {
    dragging = false;
    trusted.classList.remove('is-dragging');
  };
  trusted.addEventListener('pointerup', stopDrag);
  trusted.addEventListener('pointercancel', stopDrag);
  trusted.addEventListener('mouseenter', () => {
    paused = true;
  });
  trusted.addEventListener('mouseleave', () => {
    paused = false;
  });
  trusted.addEventListener('focusin', () => {
    paused = true;
  });
  trusted.addEventListener('focusout', () => {
    paused = false;
  });

  if (enableLoop()) {
    requestAnimationFrame(tick);
  }
}

function syncIndustryFeatureCard(desc) {
  const button = desc.closest('.industry-feature-card')?.querySelector('.js-industry-feature-more');
  if (!button) {
    return;
  }
  const truncated = desc.scrollHeight > desc.clientHeight + 2;
  button.classList.toggle('hidden', !truncated);
  if (!truncated) {
    button.setAttribute('aria-expanded', 'false');
  }
}

document.querySelectorAll('.js-industry-feature-desc').forEach((desc) => {
  const card = desc.closest('.industry-feature-card');
  const button = card?.querySelector('.js-industry-feature-more');
  button?.addEventListener('click', () => {
    const icon = card?.querySelector('.industry-feature-card__icon i');
    const title = card?.querySelector('.industry-feature-card__title')?.textContent?.trim() || '';
    const text = desc.textContent?.trim() || '';
    const iconHost = document.getElementById('industry-feature-detail-icon');
    const titleNode = document.getElementById('industry-feature-detail-title');
    const textNode = document.getElementById('industry-feature-detail-text');
    if (iconHost && icon) {
      iconHost.innerHTML = '';
      iconHost.appendChild(icon.cloneNode(true));
    }
    if (titleNode) {
      titleNode.textContent = title;
    }
    if (textNode) {
      textNode.textContent = text;
    }
    openOverlay('industry-feature-detail');
  });
  syncIndustryFeatureCard(desc);
});

const refreshIndustryLayout = () => {
  document.querySelectorAll('.js-industry-feature-desc').forEach(syncIndustryFeatureCard);
};

window.addEventListener('load', refreshIndustryLayout);
window.addEventListener('resize', refreshIndustryLayout);

document.querySelectorAll('.js-cap-transform').forEach((root) => {
  const buttons = [...root.querySelectorAll('[data-cap-format]')];
  const outputs = [...root.querySelectorAll('[data-cap-output]')];
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const selected = button.dataset.capFormat;
      buttons.forEach((item) => {
        item.setAttribute('aria-pressed', String(item === button));
      });
      outputs.forEach((output) => {
        output.hidden = output.dataset.capOutput !== selected;
      });
    });
  });
});

document.querySelectorAll('.js-cap-delivery').forEach((root) => {
  const buttons = [...root.querySelectorAll('[data-cap-scenario]')];
  const notes = [...root.querySelectorAll('[data-cap-scenario-note]')];
  const recipientStatus = root.querySelector('[data-cap-recipient-status]');
  const availableStatus = recipientStatus?.textContent?.trim() || 'ACK';
  buttons.forEach((button, buttonIndex) => {
    button.addEventListener('click', () => {
      const selected = button.dataset.capScenario;
      const isError = buttonIndex > 0;
      root.dataset.capDeliveryState = isError ? 'error' : 'normal';
      buttons.forEach((item) => {
        item.setAttribute('aria-pressed', String(item === button));
      });
      notes.forEach((note) => {
        note.hidden = note.dataset.capScenarioNote !== selected;
      });
      if (recipientStatus) {
        recipientStatus.textContent = isError ? 'Нет ответа' : availableStatus;
      }
    });
  });
});

document.querySelectorAll('.cap-v3').forEach((root) => {
  root.querySelectorAll('[data-tabs]').forEach((group) => {
    group.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button || !group.contains(button)) return;
      group.querySelectorAll('button').forEach((candidate) => {
        candidate.setAttribute('aria-pressed', String(candidate === button));
      });
      const demo = group.closest('[data-demo]');
      const result = demo?.querySelector('[data-result]');
      const choice = Number(button.dataset.choice);
      if (!demo || !result) return;

      if (demo.dataset.demo === 'test') {
        const messages = [
          '<strong>Успешный ответ.</strong> Проверяется обработка данных и переход к следующему шагу.',
          '<strong>Ошибка системы.</strong> Проверяется ветка обработки ошибки и диагностический результат.',
          '<strong>Нет ответа.</strong> Проверяется поведение маршрута при недоступном получателе.',
        ];
        result.innerHTML = messages[choice] ?? messages[0];
      } else if (demo.dataset.demo === 'cluster') {
        demo.querySelectorAll('.scheme-node').forEach((node, index) => {
          const standby = choice === 1 && index > 0;
          node.classList.toggle('standby', standby);
          const status = node.querySelector('small');
          if (status) status.textContent = standby ? 'Резерв' : 'Обработка';
        });
        result.textContent = choice
          ? 'Активный узел обрабатывает потоки, резервные узлы ожидают переключения.'
          : 'Узлы участвуют в обработке нагрузки.';
      } else if (demo.dataset.demo === 'admin') {
        const modes = [
          ['Web-консоль', 'Интерактивная настройка, управление и мониторинг.'],
          ['CLI', 'Поддерживаемые операции в автоматизированных сценариях.'],
          ['API', 'Программное управление из внешних систем.'],
        ];
        const title = result.querySelector('strong');
        const description = result.querySelector('small');
        if (title) title.textContent = modes[choice]?.[0] ?? modes[0][0];
        if (description) description.textContent = modes[choice]?.[1] ?? modes[0][1];
      }
    });
  });

  root.querySelectorAll('[data-demo="scale"]').forEach((demo) => {
    const input = demo.querySelector('input[type="range"]');
    input?.addEventListener('input', () => {
      const value = Number(input.value);
      const output = demo.querySelector('output');
      if (output) output.textContent = input.value;
      demo.querySelectorAll('[data-node]').forEach((node) => {
        const disabled = Number(node.dataset.node) > value;
        node.classList.toggle('off', disabled);
        const status = node.querySelector('small');
        if (status) status.textContent = disabled ? 'Не добавлен' : 'Обработка';
      });
    });
  });

  root.querySelectorAll('[data-demo="logs"]').forEach((demo) => {
    demo.querySelector('input')?.addEventListener('input', (event) => {
      const query = event.target.value.trim().toLocaleLowerCase('ru');
      let visible = 0;
      demo.querySelectorAll('.log-row').forEach((row) => {
        row.hidden = !row.textContent.toLocaleLowerCase('ru').includes(query);
        if (!row.hidden) visible += 1;
      });
      const empty = demo.querySelector('.empty');
      if (empty) empty.hidden = visible > 0;
    });
  });

  const list = root.querySelector('.spec-list');
  const search = root.querySelector('.spec-search');
  const toggle = root.querySelector('.toggleall');
  const empty = root.querySelector('.spec-empty');
  const syncToggle = () => {
    if (!list || !toggle) return;
    const visible = [...list.querySelectorAll('.spec')].filter((item) => !item.hidden);
    const allOpen = visible.length > 0 && visible.every((item) => item.open);
    toggle.textContent = allOpen ? 'Свернуть всё' : 'Раскрыть всё';
    toggle.setAttribute('aria-expanded', String(allOpen));
  };
  const reveal = (id) => {
    const target = root.querySelector(`#${CSS.escape(id)}`);
    if (!target?.classList.contains('spec')) return;
    if (search && list) {
      search.value = '';
      list.querySelectorAll('.spec').forEach((item) => { item.hidden = false; });
      if (empty) empty.hidden = true;
    }
    target.open = true;
    syncToggle();
  };

  search?.addEventListener('input', () => {
    const query = search.value.trim().toLocaleLowerCase('ru');
    let visible = 0;
    list?.querySelectorAll('.spec').forEach((item) => {
      item.hidden = !item.textContent.toLocaleLowerCase('ru').includes(query);
      if (!item.hidden) {
        visible += 1;
        if (query) item.open = true;
      }
    });
    if (empty) empty.hidden = visible > 0;
    syncToggle();
  });
  toggle?.addEventListener('click', () => {
    const visible = [...list.querySelectorAll('.spec')].filter((item) => !item.hidden);
    const shouldOpen = !visible.every((item) => item.open);
    visible.forEach((item) => { item.open = shouldOpen; });
    syncToggle();
  });
  list?.querySelectorAll('.spec').forEach((item) => item.addEventListener('toggle', syncToggle));
  root.querySelectorAll('a[data-spec]').forEach((link) => {
    link.addEventListener('click', () => reveal(link.hash.slice(1)));
  });
  if (window.location.hash) reveal(decodeURIComponent(window.location.hash.slice(1)));
});

document.querySelectorAll('.js-insights-hub').forEach((root) => {
  const cards = [...root.querySelectorAll('[data-insights-card]')];
  const filters = [...root.querySelectorAll('[data-insights-filter]')];
  const search = root.querySelector('[data-insights-search]');
  const count = root.querySelector('[data-insights-count]');
  const empty = root.querySelector('[data-insights-empty]');
  const fixedCategory = root.dataset.insightsFixedCategory ?? '';
  const countLabels = fixedCategory
    ? [
        root.dataset.insightsCountOne ?? 'материал',
        root.dataset.insightsCountFew ?? 'материала',
        root.dataset.insightsCountMany ?? 'материалов',
      ]
    : ['материал', 'материала', 'материалов'];
  let activeCategory = fixedCategory || 'all';

  const normalize = (value) => value
    .toLocaleLowerCase('ru')
    .replaceAll('ё', 'е')
    .replace(/\s+/g, ' ')
    .trim();

  const update = () => {
    const query = normalize(search?.value ?? '');
    const matching = cards.filter((card) => {
      const categoryMatches = activeCategory === 'all' || card.dataset.category === activeCategory;
      return categoryMatches && (!query || normalize(card.dataset.search ?? card.textContent).includes(query));
    });
    cards.forEach((card) => {
      card.hidden = !matching.includes(card);
    });
    if (count) count.textContent = matching.length === cards.length
      ? `${matching.length} ${pluralizeRu(matching.length, countLabels)}`
      : `Найдено: ${matching.length}`;
    if (empty) empty.hidden = matching.length > 0;
  };

  filters.forEach((filter) => {
    filter.addEventListener('click', () => {
      activeCategory = filter.dataset.insightsFilter ?? 'all';
      filters.forEach((candidate) => {
        candidate.setAttribute('aria-pressed', String(candidate === filter));
      });
      update();
    });
  });
  search?.addEventListener('input', update);
  update();
});

document.querySelectorAll('.js-industry-hub').forEach((root) => {
  const cards = [...root.querySelectorAll('[data-industry-card]')];
  const groups = [...root.querySelectorAll('[data-industry-group]')];
  const filters = [...root.querySelectorAll('[data-industry-filter]')];
  const search = root.querySelector('[data-industry-search]');
  const count = root.querySelector('[data-industry-count]');
  const empty = root.querySelector('[data-industry-empty]');
  let activeCategory = 'all';

  const normalize = (value) => value
    .toLocaleLowerCase('ru')
    .replaceAll('ё', 'е')
    .replace(/\s+/g, ' ')
    .trim();

  const update = () => {
    const query = normalize(search?.value ?? '');
    let visible = 0;

    cards.forEach((card) => {
      const categoryMatches = activeCategory === 'all' || card.dataset.category === activeCategory;
      const searchMatches = !query || normalize(card.dataset.search ?? card.textContent).includes(query);
      card.hidden = !(categoryMatches && searchMatches);
      if (!card.hidden) visible += 1;
    });

    groups.forEach((group) => {
      group.hidden = ![...group.querySelectorAll('[data-industry-card]')]
        .some((card) => !card.hidden);
    });
    if (count) {
      count.textContent = visible === cards.length
        ? `${visible} ${pluralizeRu(visible, ['отрасль', 'отрасли', 'отраслей'])}`
        : `Найдено: ${visible}`;
    }
    if (empty) empty.hidden = visible > 0;
  };

  filters.forEach((filter) => {
    filter.addEventListener('click', () => {
      activeCategory = filter.dataset.industryFilter ?? 'all';
      filters.forEach((candidate) => {
        candidate.setAttribute('aria-pressed', String(candidate === filter));
      });
      update();
    });
  });
  search?.addEventListener('input', update);
  update();
});

function setRichSliderIndex(slider, index) {
  if (!slider) return;
  const slides = [...slider.querySelectorAll('.rc-slide')];
  const dots = [...slider.querySelectorAll('.rc-slider__dot')];
  if (!slides.length) return;

  const normalizedIndex = Math.max(0, Math.min(index, slides.length - 1));
  const prevIndex = (normalizedIndex - 1 + slides.length) % slides.length;
  const nextIndex = (normalizedIndex + 1) % slides.length;

  slides.forEach((slide, i) => {
    slide.classList.remove('is-active', 'is-prev', 'is-next');
    if (i === normalizedIndex) {
      slide.classList.add('is-active');
      return;
    }
    if (slides.length === 2) {
      if (i !== normalizedIndex) slide.classList.add('is-next');
      return;
    }
    if (i === prevIndex) slide.classList.add('is-prev');
    else if (i === nextIndex) slide.classList.add('is-next');
  });
  dots.forEach((dot, i) => dot.classList.toggle('is-active', i === normalizedIndex));
}

function moveRichSlider(slider, delta) {
  if (!slider) return;
  const slides = [...slider.querySelectorAll('.rc-slide')];
  if (!slides.length) return;
  const currentIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
  const safeCurrentIndex = currentIndex >= 0 ? currentIndex : 0;
  setRichSliderIndex(slider, (safeCurrentIndex + delta + slides.length) % slides.length);
}

document.querySelectorAll('.js-rich-post').forEach((root) => {
  root.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const prevBtn = target.closest('.rc-slider__nav--prev');
    if (prevBtn) {
      event.preventDefault();
      moveRichSlider(prevBtn.closest('.rc-slider'), -1);
      return;
    }
    const nextBtn = target.closest('.rc-slider__nav--next');
    if (nextBtn) {
      event.preventDefault();
      moveRichSlider(nextBtn.closest('.rc-slider'), 1);
      return;
    }
    const dot = target.closest('.rc-slider__dot');
    if (dot) {
      event.preventDefault();
      const slider = dot.closest('.rc-slider');
      const dots = slider ? [...slider.querySelectorAll('.rc-slider__dot')] : [];
      const index = dots.indexOf(dot);
      if (index >= 0) setRichSliderIndex(slider, index);
    }
  });
});

function slugifyHeading(text) {
  const base = text
    .trim()
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s-]/gu, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
  return base || 'section';
}

function stripTrailingPeriod(label) {
  return label.replace(/\.(\s*)$/, '$1').trim();
}

function initArticleInsight(root) {
  if (!root) return;

  const tocNav = root.closest('.article-insight')?.querySelector('.article-toc');
  const tocList = tocNav?.querySelector('#article-toc-list');
  if (!tocList) return;

  const headings = [...root.querySelectorAll('.rc-text-block h2, .rc-text-block h3, h2, h3')].filter(
    (el) => root.contains(el) && !el.closest('.rc-html-block'),
  );

  const usedIds = new Map();
  const links = [];

  headings.forEach((heading) => {
    if (heading.tagName !== 'H2') return;

    const label = stripTrailingPeriod(heading.textContent ?? '');
    if (!label) return;

    let id = heading.id;
    if (!id) {
      const slug = slugifyHeading(label);
      const count = (usedIds.get(slug) ?? 0) + 1;
      usedIds.set(slug, count);
      id = count > 1 ? `${slug}-${count}` : slug;
      heading.id = id;
    }

    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = `#${id}`;
    link.textContent = label;
    link.addEventListener('click', (event) => {
      event.preventDefault();
      heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', `#${id}`);
      links.forEach((entry) => entry.classList.toggle('is-active', entry === link));
    });
    item.append(link);
    tocList.append(item);
    links.push(link);
  });

  if (!links.length) {
    tocNav?.classList.add('is-empty');
    tocNav?.setAttribute('aria-hidden', 'true');
    return;
  }

  tocNav?.classList.remove('is-empty');
  tocNav?.removeAttribute('aria-hidden');

  const setActive = (id) => {
    links.forEach((link) => {
      link.classList.toggle('is-active', link.getAttribute('href') === `#${id}`);
    });
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        if (visible[0]?.target?.id) {
          setActive(visible[0].target.id);
        }
      },
      { rootMargin: '-30% 0px -55% 0px', threshold: [0, 0.25, 0.5, 1] },
    );
    headings.forEach((heading) => {
      if (heading.tagName === 'H2' && heading.id) observer.observe(heading);
    });
  } else if (links[0]) {
    links[0].classList.add('is-active');
  }

  const hash = window.location.hash.replace(/^#/, '');
  if (hash) {
    const target = document.getElementById(hash);
    if (target) {
      setActive(hash);
      requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
    }
  }
}

function initArticleShare(article) {
  const button = article?.querySelector('.js-article-share');
  const toast = article?.querySelector('.js-article-share-toast');
  if (!button) return;

  button.addEventListener('click', async () => {
    const url = window.location.href.split('#')[0];
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const input = document.createElement('input');
        input.value = url;
        document.body.append(input);
        input.select();
        document.execCommand('copy');
        input.remove();
      }
      if (toast) {
        toast.hidden = false;
        toast.classList.add('is-visible');
        window.setTimeout(() => {
          toast.classList.remove('is-visible');
          toast.hidden = true;
        }, 2200);
      }
    } catch {
      /* ignore */
    }
  });
}

document.querySelectorAll('.article-insight').forEach((article) => {
  const content = article.querySelector('.js-article-insight');
  initArticleInsight(content);
  initArticleShare(article);
});

applyEditorialTypography();
